/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'licensing';
const componentName = 'licensing-get-started';
const prefix = `${moduleName}.${componentName}`;

export const cloudLicensingDescription = `${prefix}.cloudLicensingDescription`;
export const cloudLicensingLabel = `${prefix}.cloudLicensingLabel`;
export const connectToCloudLicensingLabel = `${prefix}.connectToCloudLicensingLabel`;
export const defaultTierSwitchErrorMessage = `${prefix}.defaultTierSwitchErrorMessage`;
export const failedToConnectCloudLicensingError = `${prefix}.failedToConnectCloudLicensingError`;
export const getStartedLabel = `${prefix}.getStartedLabel`;
export const licensingConnectivityError = `${prefix}.licensingConnectivityError`;
export const onBoardingInstructionLabel = `${prefix}.onBoardingInstructionLabel`;
export const onPremLicensingServiceDescription = `${prefix}.onPremLicensingServiceDescription`;
export const onPremLicensingServiceLabel = `${prefix}.onPremLicensingServiceLabel`;
export const orLabel = `${prefix}.orLabel`;
export const switchedToLicensingTypeMessage = `${prefix}.switchedToLicensingTypeMessage`;
export const useOnPremLicensingServiceLabel = `${prefix}.useOnPremLicensingServiceLabel`;

export const ENGLISH = {
    [cloudLicensingDescription]: 'Connect to cloud licensing to enable automatic license management and get access to the latest features.',
    [cloudLicensingLabel]: 'Cloud Licensing',
    [connectToCloudLicensingLabel]: 'Connect to Cloud Licensing',
    [defaultTierSwitchErrorMessage]: 'An error occurred while switching license tier.',
    [failedToConnectCloudLicensingError]: 'Failed to connect to cloud licensing. Please try again.',
    [getStartedLabel]: 'GET STARTED',
    [licensingConnectivityError]: 'There were some problem with license connectivity. Please try again.',
    [onBoardingInstructionLabel]: 'On Boarding Instruction',
    [onPremLicensingServiceDescription]: 'For enhanced control, use an On-prem License Hub. Manage licenses locally and maintain full control over your licensing environment.',
    [onPremLicensingServiceLabel]: 'On-prem License Hub',
    [orLabel]: 'or',
    [switchedToLicensingTypeMessage]: 'Switched to {0}',
    [useOnPremLicensingServiceLabel]: 'USE ON-PREM LICENSE HUB',
};
